import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';

const EditableTextBox = ({ initialValue, onSave, minWidth = '200px' }) => {
  const [value, setValue] = useState(initialValue);
  const [isEditing, setIsEditing] = useState(false);

  const saveAndExit = () => {
    setIsEditing(false);
    if (value !== initialValue) {
      onSave?.(value);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      saveAndExit();
    }
  };

  const sharedStyle = {
    minWidth: minWidth,
  };

  return isEditing ? (
    <input
      style={sharedStyle}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={saveAndExit}
      onKeyDown={handleKeyDown}
      autoFocus
    />
  ) : (
      <div
        onClick={() => setIsEditing(true)}
        style={{ ...sharedStyle, minHeight: '2rem', cursor: 'pointer', border: '1px dashed #ccc', padding: '3px' }}>
        {value || <span style={{ color: '#999' }}></span>}
    </div>
  );
};

export default EditableTextBox;
